/** Decorative distant landscape; no geographic meaning or rasterized UI text. */
export function MountainBackdrop() {
  return (
    <svg
      className="p01-mountains"
      viewBox="0 0 1600 160"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="p01-mountain-reveal">
          <stop offset="0" stopColor="white" stopOpacity="0" />
          <stop offset=".23" stopColor="white" stopOpacity="0" />
          <stop offset=".39" stopColor="white" stopOpacity=".8" />
          <stop offset=".72" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity=".3" />
        </linearGradient>
        <mask id="p01-mountain-mask">
          <rect width="1600" height="160" fill="url(#p01-mountain-reveal)" />
        </mask>
        <linearGradient id="p01-mountain-mist" x1="0" y1="0" x2="0" y2="1">
          <stop stopColor="#b9dff6" stopOpacity=".28" />
          <stop offset="1" stopColor="#e2f3fc" stopOpacity=".75" />
        </linearGradient>
      </defs>
      <g mask="url(#p01-mountain-mask)">
        <path
          d="M0 143 Q200 132 354 140 L409 124 448 131 486 108 513 116 538 89 557 99 580 76 598 81 618 66 632 79 647 74 669 96 690 88 714 104 741 91 764 99 790 82 816 87 841 74 859 90 880 82 906 94 923 83 944 88 969 64 983 72 1001 53 1018 66 1037 58 1059 79 1080 68 1106 88 1131 77 1166 90 1200 67 1241 84 1279 75 1317 95 1370 83 1431 104 1500 89 1600 102V160H0Z"
          fill="url(#p01-mountain-mist)"
        />
        <path
          d="M0 149 Q237 147 405 143 L463 137 491 120 517 127 548 109 572 113 603 95 631 109 656 103 687 120 716 110 743 122 781 106 811 114 847 95 872 103 902 84 920 94 939 89 964 107 994 97 1029 118 1056 103 1084 109 1117 88 1146 100 1174 91 1201 106 1239 98 1279 111 1318 96 1360 114 1410 102 1470 119 1530 108 1600 120V160H0Z"
          fill="#cce9f9"
          opacity=".63"
        />
        <path
          d="M0 158 Q261 152 451 150 L505 142 548 149 586 134 615 139 648 124 677 132 708 119 733 127 756 121 786 139 818 131 846 144 873 136 909 123 938 128 963 111 983 116 1001 104 1023 118 1055 109 1083 129 1111 117 1148 135 1179 124 1218 139 1251 121 1288 134 1321 121 1361 138 1404 127 1460 145 1514 134 1600 145V160H0Z"
          fill="#b8dff5"
          opacity=".58"
        />
        <path
          d="M0 160 Q350 157 552 155 Q613 143 653 149 L699 139 732 146 766 133 797 141 831 130 867 143 902 137 942 151 978 141 1016 148 1052 133 1088 141 1125 128 1164 141 1205 133 1251 151 1302 143 1341 153 1400 142 1455 154 1512 148 1600 156V160Z"
          fill="#a7d7f2"
          opacity=".44"
        />
      </g>
    </svg>
  );
}
